import UpdatePid from './UpdatePid';

export default UpdatePid;
